module.exports = __webpack_public_path__ + "img/car_sedan.535bf239.png";